/** Renders the API's U+0002…U+0003 highlight markers as <mark>; all text stays plain text (no HTML is ever parsed). */
export function Highlight({ text }: { text: string }) {
  const parts = text.split(/(\u0002[^\u0003]*\u0003)/g).filter(Boolean);
  return (
    <>
      {parts.map((p, i) => (p.startsWith("\u0002")
        ? <mark key={i} className="rounded bg-amber-100 px-0.5 text-inherit dark:bg-amber-900/40">{p.slice(1, -1)}</mark>
        : <span key={i}>{p}</span>))}
    </>
  );
}
